import {
    GET_BARCODE_ITEMS_FAILURE,
    GET_BARCODE_ITEMS_SUCCESS,
} from '../actions/actionTypes';

import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';


export default function* barcodeScannerSaga(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const payload = action.payload;    
    // const url = `/occ/v2/${baseSiteId}/products/getItemForBarcode?barcode=${payload.barcode}&orderType=${payload.orderType}&externalScanner=${payload.externalScanner}`;
    const countryCode = localStorage.getItem('countryISOCode');
    let url = `/occ/v2/${baseSiteId}/products/getItemForBarcode?barcode=${payload.barcode}&orderType=${payload.orderType}&externalScanner=${payload.externalScanner}`;

    if(payload.orderType=='KE' && countryCode=='US'){
        url = url+'&salesOrg=S030';
    }else if(countryCode=='US'){
        url = url+'&salesOrg=S002';
    }else if( countryCode=='JP'){
        url = url+'&salesOrg=S024';
    }else if( countryCode=='NZ'){
        url = url+'&salesOrg=S041';
    }else if( countryCode=='AU'){
        url = url+'&salesOrg=S040';
    }else{
        // EMEA and other non-mapped countries — read salesOrg from Redux (reflects impersonated user too)
        const salesOrg = yield select((state) => state.loginReducer.salesOrg);
        if(salesOrg) url = url+'&salesOrg='+salesOrg;
    }
    try {
        const result = yield axios.get(url).then((response) => response.data);
        // const result = {
        //     brand: 'SOLERA 4.75',
        //     cfn: '5454125',
        //     dailyRate: 'N/A',
        //     description: 'CONNECTOR 5454125 4.75-5.5 CLSD LAT 25',
        //     isSet: false,
        //     materialType: 'ZUFG',
        //     ph1: 'A30',
        //     ph2: 'A30F37',
        //     ph3: 'A30F37A09',
        //     ph4: 'A30F37A09ATT',
        //     ph5: 'A30F37A09ATTAF1',
        //     salesOrg: 'S002',
        //     uom: 'EA',
        //     batchOrSerialNumber: '12345678',
        //     GTIN: '00643169205079',
        // };
        yield put({
            type: GET_BARCODE_ITEMS_SUCCESS,
            payload: result,
        });
    } catch (error) {
        yield put({
            type: GET_BARCODE_ITEMS_FAILURE,
            payload: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
